export function changeUrl(newUrl, state) {
    if(window.location.href !== newUrl) {
        window.history.pushState(state ?? {}, '', newUrl);
    }
}

export function redirect(newUrl) {
    window.location.href = newUrl;
}
